/** Translated label for an organization role; the one copy every role chip and selector uses. */
export function getRoleLabel(role, t) {
  switch (role) {
    case 'admin':
      return t('Admin');
    case 'foreman':
      return t('Foreman');
    case 'employee':
      return t('Employee');
    case 'accountant':
      return t('Accountant');
    default:
      return role || '';
  }
}
